if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-undef
  if (window._env_) __webpack_public_path__ = `${window._env_.RESOURCE_URL || ''}/`
  // eslint-disable-next-line no-undef
  else __webpack_public_path__ = '/'
}
